import { useState, useEffect, useRef } from 'react';

/**
 * Detects scroll direction for auto-hiding UI elements.
 * @param {number} threshold - minimum scrollY before tracking starts (default 80)
 * @returns {'up'|'down'} scrollDirection
 */
export default function useScrollDirection(threshold = 80) {
  const [scrollDirection, setScrollDirection] = useState('up');
  const lastScrollY = useRef(0);

  useEffect(() => {
    const DELTA = 5;

    const handleScroll = () => {
      const currentY = window.scrollY;
      if (currentY < threshold) {
        setScrollDirection('up');
        lastScrollY.current = currentY;
        return;
      }
      if (Math.abs(currentY - lastScrollY.current) < DELTA) return;
      setScrollDirection(currentY > lastScrollY.current ? 'down' : 'up');
      lastScrollY.current = currentY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return scrollDirection;
}
